import Vue from 'vue';
import Component from 'vue-class-component';
import PurchaseDetailButton from 'components/PurchaseDetailButton';
import ProductShippingSelector from 'components/ProductShippingSelector';
import NewCarousel from 'components/NewCarousel';
import CartLimit from 'assets/graphql/queries/CartLimit.graphql';
import CartQuery from 'assets/graphql/queries/Cart.graphql';
import getLastTld from 'common/services/utils/getLastTld';
import googleAnalyticsEvent from 'common/services/googleAnalytics';
import calendar from 'common/icons/Calendar.svg';
import important from 'assets/icons/Alerta_2.svg';
import useShoppingCartCleanUp from 'composables/useShoppingCartCleanUp';
import { sendItemToAnalytics } from 'common/utils/sendAnalyticsEvent';
import { addToCartService } from 'common/services/utils/addToCart';

@Component({
  apollo: {
    cart: {
      query: CartQuery,
    },
    cart_limit: {
      query: CartLimit,
    },
  },
  components: {
    PurchaseDetailButton,
    ProductShippingSelector,
    NewCarousel,
  },
  setup() {
    const { shoppingCartCleanUp } = useShoppingCartCleanUp();
    return {
      shoppingCartCleanUp,
    };
  },
  props: {
    box: {
      type: Object,
      required: true,
    },
    availableBox: {
      type: Boolean,
      required: false,
      default: true,
    },
    isBoxFriendDay: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRetailMode: {
      type: Boolean,
      default: false,
    },
  },
})
export default class PurchaseDetailBoxComponent extends Vue {
  icons = {
    calendar,
    important,
  };
  loading = false;
  buttonTouched = '';
  showError = false;
  saleButtonText = 'Comprar';
  shipping = {
    type: 'digital',
    icon: 'Email2.svg',
    iconClass: 'Email2-icon',
    description: 'Envío digital por e-mail',
    isFree: true,
    isNew: false,
  };
  goToCheckout = true;
  country = getLastTld();

  mounted() {
    // Google Optimize event triggering.
    // eslint-disable-next-line no-undef, quote-props
    this.shipping = {
      type: this.cartItems.length ? 'digital' : 'social',
      icon: this.cartItems.length ? 'Email2.svg' : 'WhatsApp.svg',
      iconClass: this.cartItems.length ? 'Email2-icon' : 'WhatsApp-icon',
      description: this.cartItems.length
        ? 'Envío digital por e-mail'
        : 'Envío por whatsapp',
      isFree: true,
      isNew: false,
    };
  }

  get cartItems() {
    return this.cart ? this.cart.items : [];
  }

  get isCartFull() {
    if (this.cart) {
      return this.cart.items.length >= this.cart_limit;
    }
    return false;
  }

  get priceInUsd() {
    if (this.box.price_in_usd && this.box.use_price_in_usd) {
      return this.box.price_in_usd;
    }
    return -1;
  }

  get defaultImageThumbnail() {
    const result = this.box.physical_images || this.box.digital_images;
    return result[0].image;
  }

  get slugUrl() {
    const params = this.$route.params;
    return { categorySlug: params.categorySlug, boxSlug: params.boxSlug };
  }
  // Creo que esto no se usa, ya que el evento está en BoxInformation
  async addToCart(box) {
    if (!this.availableBox) return;
    this.loading = !this.loading;
    const data = {
      boxId: box.id ? box.id.toString() : '',
      activityId: '',
      quantity: 1,
      isGroup: false,
      source: '',
      boxType: this.shipping.type,
      sellingSpotId: this.shipping.selling_spot_id
        ? this.shipping.selling_spot_id.toString()
        : '',
      kindId: this.shipping.kind_id ? this.shipping.kind_id.toString() : '',
    };

    await this.shoppingCartCleanUp(this.cart, data);
    const response = await addToCartService(data, this.$apollo);

    if (response.ok) {
      sendItemToAnalytics('add_to_cart', [box], undefined, {
        transaction_id: response.order?.id ?? '',
        userData: {
          email: this.userEmail,
        },
      });
      setTimeout(() => {
        googleAnalyticsEvent('Compra', 'click', 'click_CTAcompra_boxview');
        this.loading = !this.loading;
        if (this.goToCheckout) {
          window.location = `https://${
            window.location.host + response.redirect_url
          }`;
        } else {
          this.$apollo.queries.cart.refetch();
          this.$emit('showCart');
        }
      }, 1000);
    } else {
      this.loading = !this.loading;
      this.showError = !this.showError;
    }
  }
}
